/**
 * Merges per-domain JSON fragments into the single `translation` namespace object.
 * Each file under locales/<lang>/ is one top-level key (e.g. common.json → { common: {...} }).
 */
import en_common from './locales/en/common.json';
import en_navigation from './locales/en/navigation.json';
import en_auth from './locales/en/auth.json';
import en_landing from './locales/en/landing.json';
import en_dashboard from './locales/en/dashboard.json';
import en_executors from './locales/en/executors.json';
import en_agents from './locales/en/agents.json';
import en_jobs from './locales/en/jobs.json';
import en_packages from './locales/en/packages.json';
import en_schedules from './locales/en/schedules.json';
import en_subscription from './locales/en/subscription.json';
import en_users from './locales/en/users.json';
import en_organizations from './locales/en/organizations.json';
import en_ai from './locales/en/ai.json';
import en_insights from './locales/en/insights.json';
import en_alerts from './locales/en/alerts.json';
import en_audit from './locales/en/audit.json';
import en_time from './locales/en/time.json';
import en_chat from './locales/en/chat.json';
import en_faq from './locales/en/faq.json';
import en_organization from './locales/en/organization.json';
import en_companies from './locales/en/companies.json';
import en_notifications from './locales/en/notifications.json';
import en_errors from './locales/en/errors.json';
import en_credentials from './locales/en/credentials.json';
import en_environments from './locales/en/environments.json';
import en_forms from './locales/en/forms.json';
import en_dialogs from './locales/en/dialogs.json';
import en_settings from './locales/en/settings.json';
import en_profile from './locales/en/profile.json';
import en_embeddedPage from './locales/en/embeddedPage.json';
import en_bpmnPage from './locales/en/bpmnPage.json';
import en_idpPage from './locales/en/idpPage.json';
import en_fluxosPage from './locales/en/fluxosPage.json';
import en_automationsPage from './locales/en/automationsPage.json';
import en_aiAgents from './locales/en/aiAgents.json';
import en_voiceMessaging from './locales/en/voiceMessaging.json';
import en_voiceInsights from './locales/en/voiceInsights.json';
import en_integrations from './locales/en/integrations.json';
import en_mcps from './locales/en/mcps.json';
import en_campaigns from './locales/en/campaigns.json';
import en_scopeBar from './locales/en/scopeBar.json';
import en_hybridFlows from './locales/en/hybridFlows.json';

import pt_common from './locales/pt/common.json';
import pt_navigation from './locales/pt/navigation.json';
import pt_auth from './locales/pt/auth.json';
import pt_landing from './locales/pt/landing.json';
import pt_dashboard from './locales/pt/dashboard.json';
import pt_executors from './locales/pt/executors.json';
import pt_agents from './locales/pt/agents.json';
import pt_jobs from './locales/pt/jobs.json';
import pt_packages from './locales/pt/packages.json';
import pt_schedules from './locales/pt/schedules.json';
import pt_subscription from './locales/pt/subscription.json';
import pt_users from './locales/pt/users.json';
import pt_organizations from './locales/pt/organizations.json';
import pt_ai from './locales/pt/ai.json';
import pt_insights from './locales/pt/insights.json';
import pt_alerts from './locales/pt/alerts.json';
import pt_audit from './locales/pt/audit.json';
import pt_time from './locales/pt/time.json';
import pt_chat from './locales/pt/chat.json';
import pt_faq from './locales/pt/faq.json';
import pt_organization from './locales/pt/organization.json';
import pt_companies from './locales/pt/companies.json';
import pt_notifications from './locales/pt/notifications.json';
import pt_errors from './locales/pt/errors.json';
import pt_credentials from './locales/pt/credentials.json';
import pt_environments from './locales/pt/environments.json';
import pt_forms from './locales/pt/forms.json';
import pt_dialogs from './locales/pt/dialogs.json';
import pt_settings from './locales/pt/settings.json';
import pt_profile from './locales/pt/profile.json';
import pt_embeddedPage from './locales/pt/embeddedPage.json';
import pt_bpmnPage from './locales/pt/bpmnPage.json';
import pt_idpPage from './locales/pt/idpPage.json';
import pt_fluxosPage from './locales/pt/fluxosPage.json';
import pt_automationsPage from './locales/pt/automationsPage.json';
import pt_aiAgents from './locales/pt/aiAgents.json';
import pt_voiceMessaging from './locales/pt/voiceMessaging.json';
import pt_voiceInsights from './locales/pt/voiceInsights.json';
import pt_integrations from './locales/pt/integrations.json';
import pt_mcps from './locales/pt/mcps.json';
import pt_campaigns from './locales/pt/campaigns.json';
import pt_scopeBar from './locales/pt/scopeBar.json';
import pt_hybridFlows from './locales/pt/hybridFlows.json';

import es_common from './locales/es/common.json';
import es_navigation from './locales/es/navigation.json';
import es_auth from './locales/es/auth.json';
import es_landing from './locales/es/landing.json';
import es_dashboard from './locales/es/dashboard.json';
import es_executors from './locales/es/executors.json';
import es_agents from './locales/es/agents.json';
import es_jobs from './locales/es/jobs.json';
import es_packages from './locales/es/packages.json';
import es_schedules from './locales/es/schedules.json';
import es_subscription from './locales/es/subscription.json';
import es_users from './locales/es/users.json';
import es_organizations from './locales/es/organizations.json';
import es_ai from './locales/es/ai.json';
import es_insights from './locales/es/insights.json';
import es_alerts from './locales/es/alerts.json';
import es_audit from './locales/es/audit.json';
import es_time from './locales/es/time.json';
import es_chat from './locales/es/chat.json';
import es_faq from './locales/es/faq.json';
import es_organization from './locales/es/organization.json';
import es_companies from './locales/es/companies.json';
import es_notifications from './locales/es/notifications.json';
import es_errors from './locales/es/errors.json';
import es_credentials from './locales/es/credentials.json';
import es_environments from './locales/es/environments.json';
import es_forms from './locales/es/forms.json';
import es_dialogs from './locales/es/dialogs.json';
import es_settings from './locales/es/settings.json';
import es_profile from './locales/es/profile.json';
import es_embeddedPage from './locales/es/embeddedPage.json';
import es_bpmnPage from './locales/es/bpmnPage.json';
import es_idpPage from './locales/es/idpPage.json';
import es_fluxosPage from './locales/es/fluxosPage.json';
import es_automationsPage from './locales/es/automationsPage.json';
import es_aiAgents from './locales/es/aiAgents.json';
import es_voiceMessaging from './locales/es/voiceMessaging.json';
import es_voiceInsights from './locales/es/voiceInsights.json';
import es_integrations from './locales/es/integrations.json';
import es_mcps from './locales/es/mcps.json';
import es_campaigns from './locales/es/campaigns.json';
import es_scopeBar from './locales/es/scopeBar.json';
import es_hybridFlows from './locales/es/hybridFlows.json';

export const enTranslation = {
  ...en_common,
  ...en_navigation,
  ...en_auth,
  ...en_landing,
  ...en_dashboard,
  ...en_executors,
  ...en_agents,
  ...en_jobs,
  ...en_packages,
  ...en_schedules,
  ...en_subscription,
  ...en_users,
  ...en_organizations,
  ...en_ai,
  ...en_insights,
  ...en_alerts,
  ...en_audit,
  ...en_time,
  ...en_chat,
  ...en_faq,
  ...en_organization,
  ...en_companies,
  ...en_notifications,
  ...en_errors,
  ...en_credentials,
  ...en_environments,
  ...en_forms,
  ...en_dialogs,
  ...en_settings,
  ...en_profile,
  ...en_embeddedPage,
  ...en_bpmnPage,
  ...en_idpPage,
  ...en_fluxosPage,
  ...en_automationsPage,
  ...en_aiAgents,
  ...en_voiceMessaging,
  ...en_voiceInsights,
  ...en_integrations,
  ...en_mcps,
  ...en_campaigns,
  ...en_scopeBar,
  ...en_hybridFlows
};

export const ptTranslation = {
  ...pt_common,
  ...pt_navigation,
  ...pt_auth,
  ...pt_landing,
  ...pt_dashboard,
  ...pt_executors,
  ...pt_agents,
  ...pt_jobs,
  ...pt_packages,
  ...pt_schedules,
  ...pt_subscription,
  ...pt_users,
  ...pt_organizations,
  ...pt_ai,
  ...pt_insights,
  ...pt_alerts,
  ...pt_audit,
  ...pt_time,
  ...pt_chat,
  ...pt_faq,
  ...pt_organization,
  ...pt_companies,
  ...pt_notifications,
  ...pt_errors,
  ...pt_credentials,
  ...pt_environments,
  ...pt_forms,
  ...pt_dialogs,
  ...pt_settings,
  ...pt_profile,
  ...pt_embeddedPage,
  ...pt_bpmnPage,
  ...pt_idpPage,
  ...pt_fluxosPage,
  ...pt_automationsPage,
  ...pt_aiAgents,
  ...pt_voiceMessaging,
  ...pt_voiceInsights,
  ...pt_integrations,
  ...pt_mcps,
  ...pt_campaigns,
  ...pt_scopeBar,
  ...pt_hybridFlows
};

export const esTranslation = {
  ...es_common,
  ...es_navigation,
  ...es_auth,
  ...es_landing,
  ...es_dashboard,
  ...es_executors,
  ...es_agents,
  ...es_jobs,
  ...es_packages,
  ...es_schedules,
  ...es_subscription,
  ...es_users,
  ...es_organizations,
  ...es_ai,
  ...es_insights,
  ...es_alerts,
  ...es_audit,
  ...es_time,
  ...es_chat,
  ...es_faq,
  ...es_organization,
  ...es_companies,
  ...es_notifications,
  ...es_errors,
  ...es_credentials,
  ...es_environments,
  ...es_forms,
  ...es_dialogs,
  ...es_settings,
  ...es_profile,
  ...es_embeddedPage,
  ...es_bpmnPage,
  ...es_idpPage,
  ...es_fluxosPage,
  ...es_automationsPage,
  ...es_aiAgents,
  ...es_voiceMessaging,
  ...es_voiceInsights,
  ...es_integrations,
  ...es_mcps,
  ...es_campaigns,
  ...es_scopeBar,
  ...es_hybridFlows
};
